export default "__VITE_ASSET__D$U5gE1f__"